import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { isAuthenticatedUser } from 'js/lib/user';

import AdminPermission from 'bundles/admin-shared/utils/AdminPermission';
import type { AdminHeaderUserPermissionsQuery } from 'bundles/composable-page-header-admin/providers/__generated__/AdminHeaderUserPermissionsQuery';

const adminUserPermissionsQuery = gql`
  query AdminHeaderUserPermissionsQuery {
    AdminUserPermissionsV1Resource {
      my {
        elements {
          id
          permissions
        }
      }
    }
  }
`;

// This is different from our context/provider pattern because we're accessing Naptime, using the hook here fetches the data immediately.
const useAdminHeaderPermissions = () => {
  const { data: adminPermissionData, loading: adminPermissionDataLoading } = useQuery<
    AdminHeaderUserPermissionsQuery,
    {}
  >(adminUserPermissionsQuery, {
    skip: !isAuthenticatedUser(),
    errorPolicy: 'all',
  });

  const adminPermissions: AdminPermission | undefined =
    adminPermissionData?.AdminUserPermissionsV1Resource?.my?.elements?.[0]?.permissions &&
    new AdminPermission(adminPermissionData?.AdminUserPermissionsV1Resource?.my?.elements?.[0]?.permissions);

  return { adminPermissions, adminPermissionDataLoading };
};

export default useAdminHeaderPermissions;
